import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const sendResetPasswordReducer = createReducer<State, Actions>(initialState, {
  [actions.sendResetPassword.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.sendResetPassword.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.sendResetPassword.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.sendResetPassword.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default sendResetPasswordReducer;
